/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import TableGridWithFeatures from '../../../../../../SharedModules/Table/TableGridWithFeatures';
import { DRUG_FAMILY_TABLE_COLUMNS } from '../utils/constant';
import { setDrugFamilyRow } from '../store/action';

const RequestPreviousClaimDrugFamily = ({ fullScreen, setFullScreen }) => {
  const [familyData, setFamilyData] = useState('');
  const { drugFamilyCode } = useSelector(
    (state) => state?.sharedState?.requestedPreviousClaim
  );
  const handleFullScreenViewClick = () => {
    setFullScreen(!fullScreen);
  };
  useEffect(() => {
    setFamilyData(drugFamilyCode);
  }, [drugFamilyCode]);
  const dispatch = useDispatch();
  return (
    <>
      <div className='row'>
        <div className='col-12'>
          <div className='p-0 mt-2 row'>
            <div className='mui-custom-form col-12 m-0'>
              <TableGridWithFeatures
                rowData={familyData}
                columnDefs={DRUG_FAMILY_TABLE_COLUMNS}
                fullScreenView={fullScreen}
                handleFullScreenViewClick={handleFullScreenViewClick}
                handleFullScreenView={handleFullScreenViewClick}
                gridHeight={fullScreen ? '100vh' : 350}
                enterMovesDown
                suppressCellFocus
                helpMessage=''
                data-testid='onEditingStopped'
                fileName='Provider-Status'
                onSelect={(e) => {
                  dispatch(setDrugFamilyRow(e.data));
                }}
                defaultColDef={{ filter: true }}
                exportFile={true}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RequestPreviousClaimDrugFamily;
